import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { EventService } from "src/app/core/services/event.service";
import { AiUsageLinkStateService } from "src/app/core/services/ai-usage-link-state.service";
import { PropertyModel } from "../../models/property.model";
import Swal from "sweetalert2";

import { DevelopmentsService } from "../../services/developments.services";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "src/app/core/services/auth.service";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { PropertyDataService } from "src/app/core/services/property-data.service";
import { ProposalsService } from "../../../proposals/services/proposals.service";
import { buildCharacteristicsPayload } from "../../utils/characteristics-payload.util";

@Component({
  selector: "app-create-edit-developments",
  templateUrl: "./create-edit-developments.component.html",
  styleUrls: ["./create-edit-developments.component.scss"],
})
export class CreateEditDevelopmentsComponent implements OnInit {
  textAddOrUpdateModalTitle: string = "t-add-development";
  textAddOrUpdateModal: string = "t-save";
  @ViewChild("content", { static: true }) content!: ElementRef;
  propertyForm!: FormGroup;

  subscriptions: Subscription = new Subscription();
  nabTabActive = 0;
  private currentNavTabSubject!: BehaviorSubject<number>;

  @Input()
  openModaltSubject$!: BehaviorSubject<number>;
  warningSubject$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  requiredSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  detailsForm: any;
  @Input()
  dataToFormInitDetails: any;
  addressForm: any;
  propertyAreasNearbyData: any;
  @Input()
  dataToFormInitAddress: any;
  @Input()
  dataToFormInitAreasNearby: any;
  propertyCharateristicsData: any;
  @Input()
  dataToFormInitChar: any;
  @Input()
  dataToFormInitAdvertisement: any;
  propertyAdvertisementData: any;
  propertyMultimediaData: any;
  @Input()
  dataToFormInitAgents: any;
  dataToFormInitAgentsDetails: any;
  propertyAgentsData: any;
  propertyCostumersContactsData: any;
  propertyOwnersContactsData: any;

  @Input()
  dataToFormInitPortals: any;
  propertyPortalsData: any;

  propertyProposalsData: any;

  /**
   * Horário de recebimento de propostas. A aba de propostas escreve aqui e o
   * valor segue no mesmo pedido do empreendimento, na criação e na edição.
   * `startAt` a `undefined` significa que a aba nunca foi aberta — nesse caso o
   * campo não é enviado e o que está gravado fica intacto.
   */
  proposalsWindowDraftData: { startAt?: string | null } = {};

  @Input()
  propertyDocumentsData: any;

  @Input()
  canActivateProperties!: { available: boolean; quantity: number };

  store$!: Observable<any>;
  submitted: boolean = false;
  modalClosed: boolean = false;

  showTabAreasNearby = false;
  showTabDetails = false;
  showTabAddress = false;
  showTabAreasChar = false;
  showTabAdvertisement = false;
  showTabAgents = false;
  isUpdate: boolean = false;
  propertyUpdate: any;
  propertyId: any;
  isSave = false;
  activeId!: number;
  portalsLogs: number = 0;
  canChangeBusinessStatus: boolean = true;
  statusList!: any[];
  subscriptionDataTabAgents!: Subscription;
  subscriptionCkeckWarning!: Subscription;
  subscription: Subscription;
  modalFef!: NgbModalRef;

  // --- propagate development edits to fractions ---
  @ViewChild("propagateFractionsModal") propagateFractionsModalRef!: TemplateRef<any>;
  propagateDevId: any = null;
  propagateFractionsCount = 0;
  propagateChangedFields: any[] = [];
  propagateSelection: { [key: string]: boolean } = {};
  propagatingFractions = false;

  @Input()
  property: any;
  loginUser!: {
    id?: string;
    role?: { id?: string; name?: string };
    stores?: any;
    associatedUsers?: any;
  };

  @Input()
  openProposal: any;

  typeSelected!: number;

  propertyReviewData: any;
  unitsTypes: any;
  unitsData: any;

  constructor(
    private eventService: EventService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private propertiesService: DevelopmentsService,
    private cdr: ChangeDetectorRef,
    public translate: TranslateService,
    public authService: AuthService,
    public permissionsService: PermissionsService,
    private proposalsService: ProposalsService,
    private propertyDataService: PropertyDataService,
    private aiUsageLink: AiUsageLinkStateService
  ) {
    this.currentNavTabSubject = new BehaviorSubject<number>(this.nabTabActive);
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    const updateProposalsSub = this.eventService.subscribe(
      "update-proposals-dev",
      (data) => (this.propertyProposalsData = data)
    );
    const canChangeSub = this.eventService.subscribe(
      "can-change-business-status-dev",
      (value) => (this.canChangeBusinessStatus = value)
    );
    this.subscriptions.add(updateProposalsSub);
    this.subscriptions.add(canChangeSub);
    this.unitsTypes = this.dataToFormInitDetails?.propertyTypes?.filter(
      (type: any) => type?.description !== "---" && type?.description !== "N/A"
    );
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.loadJs();
    const { id, role, stores, associatedUsers } = this.propertiesService.getUserAuth();
    this.loginUser = { id, role, stores, associatedUsers };
    this.getStatus();
    this.activeId = this.dataToFormInitAdvertisement?.activeId;
    this.openModal(this.property, this.content);

    if (!this.subscriptionDataTabAgents)
      this.subscriptionDataTabAgents = this.eventService.subscribe(
        "data-tab-agents-dev",
        (data) => {
          if (!this.modalClosed) {
            this.propertyAgentsData = data;
            this.dataToFormInitAgentsDetails = data;
          }
        }
      );

    //get regions by country
    const subscriptionRegions = this.eventService.subscribe(
      "get-data-address-regions-dev",
      (data) => {
        this.propertiesService
          .getDataForAddressRegions(data.cid)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-regions", data);
          });
      }
    );
    this.subscriptions.add(subscriptionRegions);

    //get districts by region
    const subscriptionDistricts = this.eventService.subscribe(
      "get-data-address-districts-dev",
      (data) => {
        this.propertiesService
          .getDataForAddressDistrict(data.rid)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-districts", data);
          });
      }
    );
    this.subscriptions.add(subscriptionDistricts);

    //get counties by district
    const subscriptionCounties = this.eventService.subscribe(
      "get-data-address-counties-dev",
      (data) => {
        this.propertiesService
          .getDataForAddressCounties(data.did)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-counties", data);
          });
      }
    );
    this.subscriptions.add(subscriptionCounties);

    //get parishes by county
    const subscriptionParishes = this.eventService.subscribe(
      "get-data-address-parishes-dev",
      (data) => {
        this.propertiesService
          .getDataForAddressParish(data.cid)
          .subscribe((data) => {
            this.eventService.broadcast("set-data-address-parishes", data);
          });
      }
    );

    this.subscriptions.add(subscriptionParishes);
    const subscriptionCkeckW = this.eventService.subscribe(
      "ckeck-warning-add-dev",
      (data) => {
        this.checkWarning();
      }
    );
    this.subscriptions.add(subscriptionCkeckW);

    this.subscriptionCkeckWarning = this.eventService.subscribe(
      "store-data-to-form-init-agents-dev",
      (data) => {
        this.dataToFormInitAgents = data;

        let agentMaain = this.dataToFormInitAgents?.find(
          (a: any) => a.id === this.propertiesService.getUserAuth().id
        );
        if (this.isStoreOperatorAgent(agentMaain)) {
          agentMaain = null;
        }

        if (this.propertiesService.getUserAuth().role?.name === "MASTER") {
          agentMaain = this.dataToFormInitAgents.find((a1: any) =>
            this.propertyAgentsData?.find(
              (a2: any) => a2.id === a1.id && a2.isMain === true
            )
          );
          if (this.isStoreOperatorAgent(agentMaain)) {
            agentMaain = null;
          }
        }

        if (agentMaain) {
          this.propertyAgentsData = this.dataToFormInitAgents.filter(
            (a1: any) =>
              a1.id !== agentMaain.id &&
              this.propertyAgentsData?.find((a2: any) => a2.id === a1.id)
          );

          if (this.propertyAgentsData.length > 0) {
            this.propertyAgentsData.push({
              ...agentMaain,
              add: true,
              isMain: true,
              isListingAgent: true,
            });
          } else
            this.propertyAgentsData = [
              { ...agentMaain, add: true, isMain: true, isListingAgent: true },
            ];
        } else this.propertyAgentsData = [];

        this.eventService.broadcast("set-store-data-to-form-init-agents-dev", {
          propertyAgentsData: this.propertyAgentsData,
        });
        this.cdr.detectChanges();
      }
    );

    const subscriptionchangeTabAddProperty = this.eventService.subscribe(
      "change-tab-add-property-dev",
      (data) => {
        this.nabTabActive = data;
        this.currentNavTabSubject.next(this.nabTabActive);
        this.cdr.detectChanges();
      }
    );
    this.subscriptions.add(subscriptionchangeTabAddProperty);
  }

  getStatus() {
    this.proposalsService.getStatus().subscribe((status: any[]) => {
      this.statusList = status;
    });
  }

  checkWarning() {
    if (!this.modalClosed) {
      let val: number = 0;
      if (this.detailsForm?.errors)
        for (const pd of this.detailsForm?.errors) {
          val++;
        }
      if (this.addressForm?.errors)
        for (const pd of this.addressForm?.errors) {
          val++;
        }

      if (
        this.propertyAdvertisementData?.errors.length ===
        this.dataToFormInitAdvertisement?.langs?.length
      ) {
        val++;
      }

      if (this.propertyMultimediaData?.errors.length === 1) {
        val++;
      }

      if (
        !this.canActivateProperties?.available &&
        !this.propertyUpdate?.status
      ) {
        val++;
      }
      setTimeout(() => {
        this.warningSubject$.next(val);
      });

      const errordetailsForm = this.detailsForm?.errors.filter((e: any) => {
        return e.type?.required || (e.key === "reference" && e.type?.warning);
      });
      if (errordetailsForm?.length > 0) {
        this.requiredSubject$.next(true);
      } else {
        this.requiredSubject$.next(false);
      }
    }
  }

  openModal(propertyUpdate: PropertyModel, content: any) {
    this.propertyId = undefined;
    this.submitted = false;
    this.isUpdate = propertyUpdate ? true : false;

    this.modalClosed = false;
    this.nabTabActive = 1;
    this.activeIdChangeNabTab();

    if (propertyUpdate) {
      this.propertyId = propertyUpdate.id;
      this.propertyUpdate = propertyUpdate;
      this.textAddOrUpdateModalTitle = "t-edit-development";
      this.propertiesService.getBy(propertyUpdate.id).subscribe((data) => {
        if (this.propertyUpdate.id) {
          this.propertyUpdate = { ...data, id: propertyUpdate.id };
          this.unitsData = this.propertyUpdate.units;
          this.property.entity = this.propertyUpdate.entity;
        }
        this.portalsLogs = data?.portalsLogs;
        this.canChangeBusinessStatus = data?.canChangeBusinessStatus;
        this.initForms(data);
        this.modal(content);
        if (this.openProposal) {
          setTimeout(() => {
            this.nabTabActive = 11;
            this.activeIdChangeNabTab();
          }, 200);
        }
      });
    } else {
      this.propertyUpdate = undefined;
      this.textAddOrUpdateModalTitle = "t-add-development";
      this.initForms(null);
      this.modal(content);
    }
  }

  modal(content: any) {
    this.modalFef = this.modalService.open(content, {
      size: "fullscreen",
      centered: true,
      scrollable: true,
      backdrop: "static",
      keyboard: false,
      modalDialogClass: "no-scroll-body",
      windowClass: "modal-create-properties modal-dev",
      backdropClass: "modal-back-dev",
    });

    this.modalFef.dismissed.subscribe(() => {
      this.resetForms();
      this.modalClosed = true;
      this.submitted = false;
      this.openModaltSubject$.next(0);
      this.eventService.broadcast("is-open-modal-dev", false);
    });

    this.modalFef.closed.subscribe(() => {
      this.resetForms();
      this.modalClosed = true;
      this.submitted = false;
      this.openModaltSubject$.next(0);
      this.eventService.broadcast("is-open-modal-dev", false);
    });
  }
  activeIdChangeNabTab() {
    this.currentNavTabSubject.next(this.nabTabActive);
  }
  async saveProperty(isBtnWarning = false) {
    // Fotos ainda a ser preparadas (uma de cada vez): gravar agora enviava
    // a lista incompleta.
    if (this.propertyMultimediaData?.preparingImages) {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "info",
        title: this.translate.instant("t-preparing-images", {
          current: "…",
          total: "…",
        }),
        showConfirmButton: false,
        timer: 2500,
      });
      return;
    }
    this.submitted = true;
    this.eventService.broadcast("get-data-tab-details-dev");
    this.eventService.broadcast("get-data-tab-address-dev");
    this.eventService.broadcast("get-data-tab-areas-nearby-dev");
    this.eventService.broadcast("get-data-tab-charateristics-dev");
    this.eventService.broadcast("get-data-tab-advertisement-dev", {
      submitted: true,
    });
    this.eventService.broadcast("get-data-tab-agents-dev");
    this.eventService.broadcast("get-data-tab-multimedia-dev");
    this.eventService.broadcast("get-data-tab-contacts-dev");
    this.eventService.broadcast("get-data-tab-portals-dev");
    this.eventService.broadcast("get-data-tab-units");

    if (this.warningSubject$.getValue() > 0 && !isBtnWarning) {
      const btnShowtores = document.getElementById("btn-property-warning-dev");
      if (btnShowtores) {
        btnShowtores.click();
      }
    } else {
      const btnCloseWarnning = document.getElementById("btn-warning-no");
      if (btnCloseWarnning) {
        btnCloseWarnning.click();
      }
      let dataProp: any = {};
      let divisions: any = [];
      let nearby: any = [];
      let advertisement: any = {};
      let agents: any = [];
      let videos: any = [];
      let deleteVideos: any = [];
      let imagesOrder: any = [];
      let docsAux: any = [];
      let portals: any = [];

      const keyDetailsForm = [
        "endDateMediation",
        "startDateMediation",
        "saleDate",
        "ecExpirationDate",
        "reference",
        "associatedProperty",
        "useLicense",
        "buildingLicense",
        "dateLicense",
        "technicalSheetLicense",
        "hideExclusive",
        "hidePrice",
        "hidePriceValue",
        "hideECNumber",
        "hideECExpirationDate",
        "hideUseLicense",
        "hideDateLicense",
        "hideTechnicalSheetLicense",
        "hideBuildingLicense",
        "yearOfConstruction",
        "expectedConstructionStartDate",
        "expectedConstructionEndDate",
        "partnerEntityName",
        "isPercentageCommission",
        "sharedSale",
        "hideRenewableEnergy",
        "hideCarbonEmissions",
        "exclusive",
        "methodPaymentCommission",
        "yearType",
        "contractNumber",
        "paymentsConditions",
        "ecNumber",
      ];

      Object.entries(this.detailsForm?.data).forEach(([key, val]: any) => {
        const isVal = val
          ? `${val}`.trim().length !== 0
            ? true
            : false
          : false;
        if (keyDetailsForm.includes(key)) {
          dataProp[key] = val;
        } else if (!["defineEndDate", "type"].includes(key)) {
          const val1 = ["propertyType2"].includes(key)
            ? val
            : this.toNumericValue(val);
          dataProp[key] = val1;
        }
      });

      Object.entries(this.addressForm?.data).forEach(([key, val]: any) => {
        if (key == "latitude" || key == "longitude") {
          dataProp[key] = `${val}`;
        } else {
          dataProp[key] = val;
        }
      });
      const keyDivisionNearBy = [
        "usefulArea",
        "grossArea",
        "grossDependentArea",
        "grossPrivateArea",
        "landArea",
        "buildingImplantationArea",
        "hideBuildingImplantationArea",
        "hideGrossArea",
        "hideGrossDependentArea",
        "hideGrossPrivateArea",
        "hideLandArea",
        "hideUsefulArea",
      ];
      Object.entries(this.propertyAreasNearbyData?.data).forEach(
        ([key, val]: any) => {
          const isVal =
            val !== null || val !== undefined
              ? `${val}`.trim().length !== 0
                ? true
                : false
              : false;
          if (key.startsWith("division") && val) {
            const div = key.split("division");

            let count = 1;
            const areaInput = Object.entries(
              this.propertyAreasNearbyData?.data
            ).filter(([key1, val1]: any) => {
              if (`areaInput-${div[1]}-${count}` === key1) {
                count++;
                return true;
              }
              return false;
            });

            const devisionList: any = [];
            areaInput.forEach((el: any) => {
              const o = el[0].split(`areaInput-${div[1]}-`)[1];
              const v = el[1];

              devisionList.push({ order: +o, val: v });
            });
            const statusDiv =
              this.propertyAreasNearbyData.data[`hideDivision${div[1]}`];
            divisions.push({
              id: +div[1],
              val: areaInput.length,
              hide: statusDiv,
              devisionList,
            });
          } else if (key.startsWith("nearby") && val) {
            const near = key.split("nearby");
            const valNearby = Object.entries(
              this.propertyAreasNearbyData?.data
            ).filter(([key1, val1]: any) => {
              return `valNearby-${near[1]}` === key1;
            });

            const unitNearby = Object.entries(
              this.propertyAreasNearbyData?.data
            ).filter(([key1, val1]: any) => {
              return `unitNearBy-${near[1]}` === key1;
            });
            const valN: any = valNearby[0][1];
            const statusNearBy =
              this.propertyAreasNearbyData.data[`hideNearby${near[1]}`];
            nearby.push({
              id: +near[1],
              val: +valN,
              unit: unitNearby[0][1],
              hide: statusNearBy,
            });
          } else if (isVal && keyDivisionNearBy.includes(key)) {
            const arrVal = [
              "hideBuildingImplantationArea",
              "hideGrossArea",
              "hideGrossDependentArea",
              "hideGrossPrivateArea",
              "hideLandArea",
              "hideUsefulArea",
            ];
            const val1 = arrVal.includes(key) ? val : this.toNumericValue(val);
            dataProp[key] = val1;
          }
        }
      );

      if (divisions.length > 0) {
        dataProp["divisions"] = divisions;
      }
      if (nearby.length > 0) {
        dataProp["nearby"] = nearby;
      }

      const characteristicsPayload = buildCharacteristicsPayload(
        this.propertyCharateristicsData?.data,
        this.dataToFormInitChar,
      );
      if (characteristicsPayload.ids.length > 0) {
        dataProp["charateristics"] = characteristicsPayload.ids;
      }
      // Formato com valor (quantidade / opção); o back-end dá-lhe prioridade.
      dataProp["characteristics"] = characteristicsPayload.items;

      Object.entries(this.propertyAdvertisementData?.data).forEach(
        ([key, val]: any) => {
          const isVal = val
            ? `${val}`.trim().length !== 0
              ? true
              : false
            : false;
          if (key.startsWith("lang") && key.endsWith("title") && isVal) {
            const k = key.split("_");
            const lg = k[0].split("lang");
            const langId = lg[1];
            if (!advertisement["langs"]) advertisement["langs"] = [];
            advertisement["langs"].push({
              lang: +langId,
              title: this.propertyAdvertisementData.data[`lang${langId}_title`],
              description:
                this.propertyAdvertisementData.data[
                `lang${langId}_description`
                ],
              isMain: this.propertyAdvertisementData.data[`lang${langId}_main`],
            });
          }
          if (key.startsWith("option") && val) {
            const op = key.split("option");
            if (!isBtnWarning || (isBtnWarning && op[1] != this.activeId)) {
              if (!advertisement["settings"]) advertisement["settings"] = [];
              advertisement["settings"].push(+op[1]);
            }
          }
        }
      );
      if (Object.entries(advertisement).length > 0) {
        dataProp["advertisement"] = advertisement;
      }
      agents = this.propertyAgentsData?.map((ag: any) => {
        return {
          id: ag.id,
          isMain: ag.isMain,
          isListingAgent: ag?.isListingAgent,
          isSellingAgent: !this.detailsForm?.data?.sharedSale
            ? ag?.isSellingAgent
            : false,
          listingCommission: ag?.isListingAgent
            ? ag?.listingCommission
            : undefined,
          saleCommission: ag?.isSellingAgent ? ag?.saleCommission : undefined,
        };
      });
      if (agents?.length > 0) {
        dataProp["agents"] = agents;
      }

      for (const video of this.propertyMultimediaData.data?.videos) {
        if (video.isNew)
          videos.push(video.link.changingThisBreaksApplicationSecurity);
      }
      if (videos.length > 0) {
        dataProp["videos"] = videos;
      }

      deleteVideos = this.propertyMultimediaData.dataDeleteVideos?.map(
        (v: any) => {
          return v.videoId;
        }
      );
      if (deleteVideos.length > 0) {
        dataProp["videosDelete"] = deleteVideos;
      }

      if (this.propertyMultimediaData?.data?.first) {
        dataProp["multimediaFirst"] = this.propertyMultimediaData?.data?.first;
      }

      for (const image of this.propertyMultimediaData.data.images) {
        // Recorte: só viaja quando foi mexido nesta sessão (`null` = repor
        // o automático); ausente = o servidor mantém o guardado.
        const cropFields = image.cropDirty ? { crop: image.crop ?? null } : {};
        if (image.isNew) {
          imagesOrder.push({
            order: image.id,
            name: `${image.name}${image.id}`,
            fileId: 0,
            description: image.caption,
            status: image.status,
            isAiGenerated: !!image.isAiGenerated,
            aiServiceCode: image.isAiGenerated ? image.aiServiceCode || "MANUAL" : null,
            ...cropFields,
          });
        } else {
          imagesOrder.push({
            order: image.id,
            name: `${image.name}${image.id}`,
            fileId: image.fileId,
            description: image.caption,
            status: image.status,
            isAiGenerated: !!image.isAiGenerated,
            aiServiceCode: image.isAiGenerated ? image.aiServiceCode || "MANUAL" : null,
            ...cropFields,
          });
        }
      }
      if (imagesOrder.length > 0) {
        dataProp["imagesOrder"] = imagesOrder;
      }

      if (
        this.propertyCostumersContactsData.data.costumers &&
        this.propertyCostumersContactsData.data.costumers.length > 0
      ) {
        dataProp["costumers"] =
          this.propertyCostumersContactsData.data.costumers.map(
            (c: any) => +c.id
          );
      }
      if (
        this.propertyOwnersContactsData.data.owners &&
        this.propertyOwnersContactsData.data.owners.length > 0
      ) {
        dataProp["owners"] = this.propertyOwnersContactsData.data.owners.map(
          (c: any) => +c.id
        );
      }

      Object.entries(this.propertyPortalsData?.data).forEach(
        ([key, val]: any) => {
          const portal = key.split("portal")[1];
          const p = this.dataToFormInitPortals?.portals.find(
            (p: any) => p.id == portal
          );
          if (Array.isArray(val)) {
            portals.push({ id: +portal, status: val[0], isep: p?.isep });
          } else {
            portals.push({ id: +portal, status: val, isep: p?.isep });
          }
        }
      );
      if (portals.length > 0) {
        dataProp["portals"] = portals;
      }

      for (const doc of this.propertyDocumentsData.data) {
        if (doc.isNew) {
          docsAux.push({
            fileId: 0,
            name: doc.name,
            description: doc.description,
            documentVisibility: doc.documentVisibility,
            showOnWebsite: doc.showOnWebsite,
            docType: doc?.docType ? doc?.docType : undefined,
            order: doc.order,
          });
        } else {
          docsAux.push({
            fileId: doc.id,
            name: doc.name,
            description: doc.description,
            documentVisibility: doc.documentVisibility,
            showOnWebsite: doc.showOnWebsite,
            docType: doc?.docType ? doc?.docType : undefined,
            order: doc.order,
          });
        }
      }

      if (docsAux.length > 0) {
        dataProp["docsAux"] = docsAux;
      }
      if (this.unitsData?.length > 0) {
        if (this.unitsData[0]?.name) {
          if (
            this.unitsData?.some((block: any) => {
              return (
                block?.isNew ||
                block?.units?.some((u: any) => u?.isNew || u?.changeBlock)
              );
            })
          ) {
            const units = this.unitsData?.filter((block: any) => {
              return (
                block?.isNew === true ||
                block?.units?.some((u: any) => u?.isNew || u?.changeBlock)
              );
            });
            dataProp["blocks"] = units?.map((b: any) => {
              if (b?.isNew) {
                return b;
              } else {
                return {
                  ...b,
                  units: b?.units?.filter(
                    (u: any) => u?.isNew || u?.changeBlock
                  ),
                };
              }
            });
          }
        } else {
          if (this.unitsData?.some((u: any) => u?.isNew)) {
            dataProp["units"] = this.unitsData?.filter((u: any) => u?.isNew);
          }
        }
      }

      if (this.proposalsWindowDraftData?.startAt !== undefined) {
        dataProp["proposalsStartAt"] = this.proposalsWindowDraftData.startAt;
      }

      if (!this.isUpdate) {
        this.isSave = true;
        this.createProperty({ dataProp });
      } else {
        this.isSave = true;
        this.updateProperty({ dataProp });
      }
    }
  }

  /**
   * Numeric coercion that also accepts comma as the decimal separator
   * (e.g. "3,5" → 3.5). Any other value behaves exactly like `+val`.
   */
  private toNumericValue(value: any): any {
    if (typeof value === "string" && value.includes(",")) {
      const parsed = +value.replace(/\s/g, "").replace(",", ".");
      return Number.isNaN(parsed) ? +value : parsed;
    }
    return +value;
  }

  /**
   * Create user
   */
  createProperty(data: any) {
    if (this.requiredSubject$.getValue() === false) {
      let formData: any = new FormData();
      formData.append("data", JSON.stringify(data.dataProp));
      for (const image of this.propertyMultimediaData.data.images) {
        if (
          image.originalFile instanceof File ||
          image.originalFile instanceof Blob
        ) {
          formData.append(
            "images",
            this.renameFile(image.originalFile, `${image.name}${image.id}`)
          );
        } else {
          formData.append(
            "images",
            this.dataUrlToFile(image.img, `${image.name}${image.id}`)
          );
        }
      }
      for (const doc of this.propertyDocumentsData.dataUpload) {
        formData.append("docs", doc);
      }
      this.propertiesService.create(formData).subscribe(
        (data) => {
          if (data.create_property === "ref") {
            const msg = this.translate.instant(
              "t-m-properties.t-this-reference-has-already-been-used"
            );
            this.errorMsg(msg);
          } else {
            // Liga os usos de IA feitos sem id (ex.: título grátis) ao imóvel,
            // antes de fechar o modal (que limpa as chaves ao destruir o anúncio).
            this.aiUsageLink.commit(data?.resId);
            this.eventService.broadcast("refresh-properties");
            this.modalFef.dismiss();
            const msg = this.translate.instant(
              "t-m-properties.t-property-create-successfully"
            );
            this.showAlertSuccess(msg);
          }
          this.isSave = false;
        },
        (error) => {
          const msg = this.translate.instant(
            "t-m-properties.t-this-reference-has-already-been-used"
          );
          this.errorMsg(msg);
          this.isSave = false;
        },
        () => {
          console.log("complete create property");
        }
      );
    } else {
      this.isSave = false;
    }
  }

  /**
   * update property
   */
  updateProperty(data: any) {
    if (this.requiredSubject$.getValue() === false) {
      if (this.propertyMultimediaData?.dataDeleteImages?.length > 0) {
        data.dataProp["imagesDelete"] =
          this.propertyMultimediaData.dataDeleteImages.map((imgd: any) => {
            return { fileName: imgd.fileName, fileId: imgd.fileId };
          });
      }
      if (this.propertyDocumentsData?.dataDeletefiles?.length > 0) {
        data.dataProp["docsDelete"] =
          this.propertyDocumentsData.dataDeletefiles.map((doc: any) => {
            return { fileName: doc.fileName, fileId: doc.id };
          });
      }
      let formData: any = new FormData();
      formData.append("data", JSON.stringify(data.dataProp));
      for (const image of this.propertyMultimediaData.data.images) {
        if (image.isNew) {
          if (
            image.originalFile instanceof File ||
            image.originalFile instanceof Blob
          ) {
            formData.append(
              "images",
              this.renameFile(image.originalFile, `${image.name}${image.id}`)
            );
          } else {
            formData.append(
              "images",
              this.dataUrlToFile(image.img, `${image.name}${image.id}`)
            );
          }
        }
      }
      for (const doc of this.propertyDocumentsData.dataUpload) {
        formData.append("docs", doc);
      }

      this.propertiesService.update(this.propertyUpdate.id, formData).subscribe(
        (data) => {
          if (data.update_property === "ref") {
            const msg = this.translate.instant(
              "t-m-properties.t-this-reference-has-already-been-used"
            );
            this.errorMsg(msg);
          } else {
            this.eventService.broadcast("refresh-properties");
            const propagation = data?.propagation;
            const devId = this.propertyUpdate?.id;
            this.modalFef.dismiss();
            const msg = this.translate.instant(
              "t-m-properties.t-property-update-successfully"
            );
            this.showAlertSuccess(msg);
            this.eventService.broadcast("update-notifications");
            if (
              propagation?.hasFractions &&
              propagation?.changedFields?.length > 0
            ) {
              this.openPropagateFractionsModal(devId, propagation);
            }
          }
          this.isSave = false;
        },
        (error) => {
          const msg = this.translate.instant(
            "t-m-properties.t-this-reference-has-already-been-used"
          );
          this.errorMsg(msg);
          this.isSave = false;
        },
        () => {
          console.log("complete update property");
        }
      );
    } else {
      this.isSave = false;
    }
  }

  propagateGroupedFields: { group: string; label: string; fields: any[] }[] =
    [];

  openPropagateFractionsModal(devId: any, propagation: any) {
    this.propagateDevId = devId;
    this.propagateFractionsCount = propagation?.fractionsCount ?? 0;
    this.propagateChangedFields = propagation?.changedFields ?? [];
    this.propagateSelection = {};
    this.propagateChangedFields.forEach(
      (f: any) => (this.propagateSelection[f.key] = true)
    );
    this.propagateGroupedFields = this.buildPropagateGroupedFields();
    this.modalService.open(this.propagateFractionsModalRef, {
      centered: true,
      size: "lg",
      backdrop: "static",
    });
  }

  private buildPropagateGroupedFields(): {
    group: string;
    label: string;
    fields: any[];
  }[] {
    const order = [
      "details",
      "location",
      "areas",
      "characteristics",
      "advertisement",
      "agents",
      "portals",
      "media",
      "commercial",
    ];
    const groups: { [k: string]: any[] } = {};
    this.propagateChangedFields.forEach((f: any) => {
      (groups[f.group] = groups[f.group] || []).push(f);
    });
    return order
      .filter((g) => groups[g]?.length)
      .map((g) => ({
        group: g,
        label: this.translate.instant("t-propagate.t-group-" + g),
        fields: groups[g],
      }));
  }

  getPropagateFieldLabel(field: any): string {
    return field?.labelKey
      ? this.translate.instant(field.labelKey)
      : field?.key;
  }

  hasAnyPropagateSelected(): boolean {
    return this.propagateChangedFields.some(
      (f: any) => this.propagateSelection[f.key]
    );
  }

  countPropagateSelected(): number {
    return this.propagateChangedFields.filter(
      (f: any) => this.propagateSelection[f.key]
    ).length;
  }

  isPropagateGroupAllSelected(group: any): boolean {
    return group.fields.every((f: any) => this.propagateSelection[f.key]);
  }

  togglePropagateGroup(group: any) {
    const target = !this.isPropagateGroupAllSelected(group);
    group.fields.forEach(
      (f: any) => (this.propagateSelection[f.key] = target)
    );
  }

  areAllPropagateSelected(): boolean {
    return this.propagateChangedFields.every(
      (f: any) => this.propagateSelection[f.key]
    );
  }

  toggleAllPropagate() {
    const target = !this.areAllPropagateSelected();
    this.propagateChangedFields.forEach(
      (f: any) => (this.propagateSelection[f.key] = target)
    );
  }

  formatPropagateValue(value: any): string {
    if (value === null || value === undefined || value === "") return "—";
    if (value?.tKey) {
      return this.translate.instant(value.tKey, value.tParams);
    }
    if (value === true || value === "true")
      return this.translate.instant("t-propagate.t-yes");
    if (value === false || value === "false")
      return this.translate.instant("t-propagate.t-no");
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      const [y, m, d] = value.split("-");
      return `${d}/${m}/${y}`;
    }
    if (typeof value === "number") {
      return value.toLocaleString();
    }
    return `${value}`;
  }

  confirmPropagateToFractions(modal: any) {
    const fields = this.propagateChangedFields
      .filter((f: any) => this.propagateSelection[f.key])
      .map((f: any) => f.key);
    if (fields.length === 0) {
      modal.close();
      return;
    }
    this.propagatingFractions = true;
    this.propertiesService
      .propagateToFractions(this.propagateDevId, fields)
      .subscribe(
        (res: any) => {
          this.propagatingFractions = false;
          modal.close();
          this.showAlertSuccess(
            this.translate.instant("t-propagate.t-success", {
              count: res?.updated ?? 0,
            })
          );
        },
        () => {
          this.propagatingFractions = false;
          this.errorMsg(this.translate.instant("t-propagate.t-error"));
        }
      );
  }

  resetForms() {
    this.propertyDataService.updateListingImages([]);
    this.detailsForm = null;
    this.addressForm = null;
    this.propertyAreasNearbyData = null;
    this.propertyCharateristicsData = null;
    this.propertyAdvertisementData = null;
    this.propertyMultimediaData = null;
    this.propertyAgentsData = null;
    this.propertyCostumersContactsData = null;
    this.propertyOwnersContactsData = null;
    this.propertyPortalsData = null;
    this.propertyProposalsData = null;
    this.proposalsWindowDraftData = {};
    this.propertyDocumentsData = null;
  }

  initForms(property: any) {
    if (property) {
      this.detailsForm = {
        data: { ...property.details },
        errors: [],
        valid: true,
      };
      this.detailsForm.errors = this.createDetailsErrors(property);
      this.detailsForm.valid == this.detailsForm.errors.length > 0
        ? false
        : true;

      this.addressForm = {
        data: { ...property.address },
        errors: [],
        valid: true,
      };
      this.addressForm.errors = this.createAddressErrors(property);
      this.addressForm.valid =
        this.addressForm.errors.length > 0 ? false : true;

      this.propertyAreasNearbyData = {
        data: { ...property.areasNearby },
        errors: [],
        valid: true,
      };

      this.propertyCharateristicsData = {
        data: { ...property.characteristics },
        errors: [],
        valid: true,
      };

      this.propertyAdvertisementData = {
        data: { ...property.Advertisement },
        errors: [],
        valid: true,
      };
      this.propertyAdvertisementData.errors =
        this.createAdvertisementErrors(property);
      this.propertyAdvertisementData.valid =
        this.propertyAdvertisementData.errors.length > 0 ? false : true;

      this.propertyMultimediaData = {
        data: property.multimedia,
        dataDeleteImages: [],
        dataDeleteVideos: [],
        errors: [],
      };
      this.propertyMultimediaData.errors =
        this.propertyMultimediaData?.data?.images?.length > 0 ||
          this.propertyMultimediaData?.data?.images?.length > 0
          ? []
          : [{ warning: true }];
      this.propertyAgentsData = property.propertyAgents;
      setTimeout(() => {
        this.dataToFormInitAgentsDetails = this.propertyAgentsData;
        this.cdr.detectChanges();
      }, 100);

      this.propertyCostumersContactsData = {
        data: property.propertyCostumersContacts,
        dataDelete: [],
      };
      this.propertyOwnersContactsData = {
        data: property.propertyOwnersContacts,
        dataDelete: [],
      };
      this.propertyPortalsData = { ...property?.portals };
      this.propertyProposalsData = property?.proposals;
      this.propertyDocumentsData = {
        data: property.documents,
        dataUpload: [],
        dataDeletefiles: [],
      };
      this.propertyReviewData = property.review;
    } else {
      const storeMain = this.dataToFormInitDetails?.stores.find(
        (s: any) => s.isMain === true
      );

      this.detailsForm = { data: {}, errors: [], valid: false };
      this.detailsForm.data.store = storeMain?.id;
      this.detailsForm.errors = this.createDetailsErrors(property);
      this.detailsForm.valid == this.detailsForm.errors.length > 0
        ? false
        : true;

      const c = this.dataToFormInitAddress.countries.find(
        (c: any) => c.name === "---"
      );
      const r = c.regions.find((c: any) => c.name === "---");
      const d = r.districts.find((c: any) => c.name === "---");
      const co = d.counties.find((c: any) => c.name === "---");
      const p = co.parishs.find((c: any) => c.name === "---");

      this.dataToFormInitAddress.regions = c.regions;
      this.dataToFormInitAddress.districts = r.districts;
      this.dataToFormInitAddress.counties = d.counties;
      this.dataToFormInitAddress.parishes = co.parishs;
      this.addressForm = {
        data: {},
        errors: [],
        valid: true,
      };
      this.addressForm.data = {
        country: c.id,
        region: r.id,
        district: d.id,
        county: co.id,
        parish: p.id,
        latitude: this.dataToFormInitAddress.latitude,
        longitude: this.dataToFormInitAddress.longitude,
      };
      this.addressForm.errors = this.createAddressErrors(property);
      this.addressForm.valid =
        this.addressForm.errors.length > 0 ? false : true;

      this.propertyAreasNearbyData = {
        data: {},
        errors: [],
        valid: true,
        detailsForm: this.detailsForm,
      };
      this.propertyCharateristicsData = { data: {}, errors: [], valid: true };

      this.propertyAdvertisementData = { data: {}, errors: [], valid: false };
      for (let lang of this.dataToFormInitAdvertisement?.langs) {
        this.propertyAdvertisementData.data[`lang${lang.id}_title`] = "N/A";
      }

      if (this.dataToFormInitAdvertisement?.langs?.length > 0) {
        this.propertyAdvertisementData.errors =
          this.createAdvertisementErrors(property);
        this.propertyAdvertisementData.valid =
          this.propertyAdvertisementData.errors.length > 0 ? false : true;
        this.propertyAdvertisementData.data[
          `lang${this.dataToFormInitAdvertisement.langs[0].id}_main`
        ] = true;
      }

      this.propertyMultimediaData = {
        data: { images: [], videos: [] },
        dataDeleteImages: [],
        dataDeleteVideos: [],
        errors: [{ warning: true }],
      };

      let agentMaain = this.dataToFormInitAgents?.find(
        (a: any) => a.id === this.propertiesService.getUserAuth().id
      );
      if (this.isStoreOperatorAgent(agentMaain)) {
        agentMaain = null;
      }

      // fix bug
      this.dataToFormInitAgents?.forEach((d: any) => {
        d.add = false;
        d.isMain = false;
        d.isListingAgent = false;
      });

      if (agentMaain) {
        this.propertyAgentsData = [
          { ...agentMaain, add: true, isMain: true, isListingAgent: true },
        ];
      } else this.propertyAgentsData = [];

      this.propertyCostumersContactsData = {
        data: { costumers: [], total: 0 },
        dataDelete: [],
      };
      this.propertyOwnersContactsData = {
        data: { owners: [], total: 0 },
        dataDelete: [],
      };
      this.propertyPortalsData = {
        data: [],
        externalPortals: [],
        portalsLogs: [],
        aux: this.dataToFormInitPortals?.portals,
      };
      for (let p of this.dataToFormInitPortals.portals) {
        this.propertyPortalsData.data[`portal${p.id}`] =
          p.activateOnAllProperties;
      }
      this.propertyDocumentsData = {
        data: [],
        dataUpload: [],
        dataDeletefiles: [],
      };
    }
    this.checkWarning();
  }

  createDetailsErrors(property: any) {
    let errors = [
      {
        key: "reference",
        type: {
          required: true,
        },
      },
      {
        key: "propertyType",
        type: {
          warning: true,
        },
      },
      {
        key: "condition",
        type: {
          warning: true,
        },
      },
      {
        key: "businessStatus",
        type: {
          warning: true,
        },
      },
      // Classe energética fica de fora: num empreendimento não é
      // obrigatória (os imóveis normais também não a listam aqui).
      {
        key: "businessType",
        type: {
          warning: true,
        },
      },
    ];
    if (property) {
      errors = [];
      const propertyType = this.dataToFormInitDetails.propertyTypes.find(
        (s: any) => s.description === "---"
      );
      const condition = this.dataToFormInitDetails.conditions.find(
        (s: any) => s.description === "---"
      );
      const businessStatus = this.dataToFormInitDetails.businessStatus.find(
        (s: any) => s.description === "---"
      );
      const businessType = this.dataToFormInitDetails.businessTypes.find(
        (s: any) => s.description === "---"
      );

      if (propertyType.id === this.detailsForm?.data?.propertyType) {
        errors.push({
          key: "propertyType",
          type: {
            warning: true,
          },
        });
      }
      if (condition.id === this.detailsForm?.data?.condition) {
        errors.push({
          key: "condition",
          type: {
            warning: true,
          },
        });
      }
      if (businessStatus.id === this.detailsForm?.data?.businessStatus) {
        errors.push({
          key: "businessStatus",
          type: {
            warning: true,
          },
        });
      }
      if (businessType.id === this.detailsForm?.data?.businessType) {
        errors.push({
          key: "businessType",
          type: {
            warning: true,
          },
        });
      }
    }
    return errors;
  }

  createAddressErrors(property: any) {
    let errors = [
      {
        key: "country",
        type: {
          warning: true,
        },
      },
      {
        key: "region",
        type: {
          warning: true,
        },
      },
      {
        key: "district",
        type: {
          warning: true,
        },
      },
      {
        key: "county",
        type: {
          warning: true,
        },
      },
      {
        key: "parish",
        type: {
          warning: true,
        },
      },
    ];
    if (property) {
      errors = [];

      if (
        this.addressForm?.data?.country &&
        this.addressForm?.data?.countryName === "---"
      ) {
        errors.push({
          key: "country",
          type: {
            warning: true,
          },
        });
      }
      if (
        this.addressForm?.data?.region &&
        this.addressForm?.data?.regionName === "---"
      ) {
        errors.push({
          key: "region",
          type: {
            warning: true,
          },
        });
      }
      if (
        this.addressForm?.data?.district &&
        this.addressForm?.data?.districtName === "---"
      ) {
        errors.push({
          key: "district",
          type: {
            warning: true,
          },
        });
      }
      if (
        this.addressForm?.data?.county &&
        this.addressForm?.data?.countyName === "---"
      ) {
        errors.push({
          key: "county",
          type: {
            warning: true,
          },
        });
      }
      if (
        this.addressForm?.data?.parish &&
        this.addressForm?.data?.parishName === "---"
      ) {
        errors.push({
          key: "parish",
          type: {
            warning: true,
          },
        });
      }
    }
    return errors;
  }

  createAdvertisementErrors(property: any) {
    let errors = [];
    for (let lang of this.dataToFormInitAdvertisement?.langs) {
      if (
        this.propertyAdvertisementData.data[`lang${lang.id}_title`] === "N/A"
      ) {
        errors.push({
          key: `lang${lang.id}_title`,
          type: {
            warning: true,
          },
        });
      }
    }

    return errors;
  }

  base64ToFile(base64Image: string): Blob {
    const split = base64Image.split(",");
    const type = split[0].replace("data:", "").replace(";base64", "");
    const byteString = atob(split[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type });
  }

  dataUrlToFile(dataUrl: any, filename: any) {
    const split = dataUrl.split(",");
    const mime = split[0].match(/:(.*?);/)[1];
    const byteString = atob(split[1]);
    let ab = byteString.length;
    const ia = new Uint8Array(ab);
    while (ab--) {
      ia[ab] = byteString.charCodeAt(ab);
    }
    return new File([ia], filename, { type: mime });
  }

  renameFile(file: File | Blob, newName: string): File {
    const newFile = new File([file], newName, {
      type: file.type,
    });
    return newFile;
  }

  loadJs() {
    const scriptLoadBs: any = document.querySelector("#bs-js");
    if (!scriptLoadBs) {
      const node = document.createElement("script");
      node.src = "assets/libs/bootstrap/js/bootstrap.bundle.min.js";
      node.type = "text/javascript";
      node.async = true;
      node.id = "bs-js";
      document.body.appendChild(node);
    }
  }

  /**
   * Title sweet alert
   * @param Error Msg modal content
   */
  errorMsg(errorMsg: string) {
    Swal.fire({
      title: "Oops...",
      text: errorMsg,
      icon: "warning",
      confirmButtonColor: "rgb(54, 69, 116)",
      confirmButtonText: "Close",
    });
  }

  /**
   * show sweet alert success
   * @param position modal content
   */
  showAlertSuccess(msg: string) {
    Swal.fire({
      //position: 'top-end',
      icon: "success",
      title: msg,
      showConfirmButton: false,
      timer: 1500,
    });
  }
  createDateFormat(date: any) {
    const d = new Date(date);
    return d.toLocaleString();
  }

  // Delegado ao PermissionsService: um STORE OPERATOR deixa de ser excluído
  // quando a entidade liga "diretores de loja também atuam como consultores".
  private isStoreOperatorAgent(agent: any): boolean {
    return !this.permissionsService.canBeListingAgent(agent);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.subscriptionDataTabAgents)
      this.subscriptionDataTabAgents.unsubscribe();
    if (this.subscriptionCkeckWarning)
      this.subscriptionCkeckWarning.unsubscribe();
  }
}
